import { InventoryLogType } from './inventory-log-type.js';
/** Log types that revalue stock without moving it, so a zero `change_qty` on them is expected. */
export const VALUE_ONLY_LOG_TYPES = [InventoryLogType.COST_ADJUST];
//# sourceMappingURL=value-only-log-types.js.map